/**
 * Provides a list of subscribable Twitch player events.
 */
export var TwitchPlayerEvent;
(function (TwitchPlayerEvent) {
    /**
     * The video player is ready for API commands.
     */
    TwitchPlayerEvent["VIDEO_READY"] = "video.ready";
    /**
     * The video started playing. This callback receives an object with a sessionId property.
     */
    TwitchPlayerEvent["VIDEO_PLAY"] = "video.play";
    /**
     * Video or stream ends.
     */
    TwitchPlayerEvent["ENDED"] = "ended";
    /**
     * Player is paused. Buffering and seeking is not considered paused.
     */
    TwitchPlayerEvent["PAUSE"] = "pause";
    /**
     * Player just unpaused, will either start video playback or start buffering.
     */
    TwitchPlayerEvent["PLAY"] = "play";
    /**
     * Player playback was blocked. Usually fired after an unmuted autoplay or unmuted programmatic call on `play()`.
     */
    TwitchPlayerEvent["PLAYBACK_BLOCKED"] = "playbackBlocked";
    /**
     * Player started video playback.
     */
    TwitchPlayerEvent["PLAYING"] = "playing";
    /**
     * Loaded channel goes offline.
     */
    TwitchPlayerEvent["OFFLINE"] = "offline";
    /**
     * Loaded channel goes online.
     */
    TwitchPlayerEvent["ONLINE"] = "online";
    /**
     * Player is ready to accept function calls.
     */
    TwitchPlayerEvent["READY"] = "ready";
})(TwitchPlayerEvent || (TwitchPlayerEvent = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVHdpdGNoUGxheWVyRXZlbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL2V2ZXJ5dGhpbmcvdmlkZW8vVHdpdGNoUGxheWVyRXZlbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLENBQU4sSUFBWSxpQkF5Q1g7QUF6Q0QsV0FBWSxpQkFBaUI7SUFDM0I7O09BRUc7SUFDSCxnREFBMkIsQ0FBQTtJQUMzQjs7T0FFRztJQUNILDhDQUF5QixDQUFBO0lBQ3pCOztPQUVHO0lBQ0gsb0NBQWUsQ0FBQTtJQUNmOztPQUVHO0lBQ0gsb0NBQWUsQ0FBQTtJQUNmOztPQUVHO0lBQ0gsa0NBQWEsQ0FBQTtJQUNiOztPQUVHO0lBQ0gseURBQW9DLENBQUE7SUFDcEM7O09BRUc7SUFDSCx3Q0FBbUIsQ0FBQTtJQUNuQjs7T0FFRztJQUNILHdDQUFtQixDQUFBO0lBQ25COztPQUVHO0lBQ0gsc0NBQWlCLENBQUE7SUFDakI7O09BRUc7SUFDSCxvQ0FBZSxDQUFBO0FBQ2pCLENBQUMsRUF6Q1csaUJBQWlCLEtBQWpCLGlCQUFpQixRQXlDNUIifQ==